import OverviewTab from './tab-overview'
import ResourceCostTab from './tab-resource-cost'
import VendorCostTab from './tab-vendor-cost'
import OtherCostTab from './tab-other-cost'
import LicensingTab from './tab-licensing'
import HardwareTab from './tab-hardware'
// import ChangeRequestTab from './_tab-change-request'
import AttachmentTab from './tab-attachment'
import { CostPlanningTab } from './tab-cost-planning'
import { RevenuePlanningTab } from './tab-revenue-planning'
import { ChangeRequestTab } from './tab-change-request'
import { BillingTab } from './tab-billing'

export {
  OverviewTab,
  ResourceCostTab,
  VendorCostTab,
  OtherCostTab,
  LicensingTab,
  HardwareTab,
  ChangeRequestTab,
  AttachmentTab,
  CostPlanningTab,
  RevenuePlanningTab,
  BillingTab,
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/index.js